

<div fxLayout="column" fxLayoutGap="13px" fxLayoutAlign="space-between center" class="menu-desktop" >
    <div class="button" style="background: #969696 url(assets/img/layers.svg) center center no-repeat;">
        <mat-form-field appearance="none">
            <mat-select (selectionChange)="changeMapType()" [(value)]="selectedLayer">
              <mat-option value="racc">
                RACC
              </mat-option>
              <mat-option value="terrain" i18n>
                Relieve
              </mat-option>
              <mat-option value="satellite" i18n>
                Satélite
              </mat-option>
              <mat-option value="hybrid" i18n>
                Híbrido
              </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="button" (click)="print()"><img src="assets/img/print.svg" i18n-alt alt="Imprimir mapa"></div>
    <div class="button" (click)="openShareDialog()"><img src="assets/img/share.svg" i18n-alt alt="Compartir"></div>
    <a href="mailto:?subject=Feedback%20RACC%20Infotransit" class="button"><img src="assets/img/feedback.svg" i18n-alt style="top:40%;" alt="Dar feedback"></a>
    <div class="button"style="background: #969696 url(assets/img/language.svg) center center no-repeat;">
      <mat-form-field appearance="none">
        <mat-select [(value)]="selectedLanguage">
          <a href="/es">
            <mat-option [class.selected]="selectedLanguage === 'es'" value="es" >
              <img src="assets/img/espana.svg" alt=""> Español
           </mat-option>
          </a>
          
          <a href="/ca">
            <mat-option [class.selected]="selectedLanguage === 'ca'" value="ca">
              <img src="assets/img/catalonia.png" alt=""> Català
            </mat-option> 
          </a>
          
        </mat-select>
    </mat-form-field>
    </div>
</div>

<div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center" class="menu-responsive" [class.selected]="mostrarBotons">
  
  <div  class="button" *ngIf="mostrarBotons" style="background: #969696 url(assets/img/layers.svg) center center no-repeat;">
      <mat-form-field appearance="none">
          <mat-select (selectionChange)="changeMapType()" [(value)]="selectedLayer">
            <mat-option value="racc">
              RACC
            </mat-option>
            <mat-option value="terrain" i18n>
              Relieve
            </mat-option>
            <mat-option value="satellite" i18n>
              Satélite
            </mat-option>
            <mat-option value="hybrid" i18n>
              Híbrido
            </mat-option>
          </mat-select>
      </mat-form-field>
  </div>
  <div  class="button" *ngIf="mostrarBotons" (click)="print()"><img src="assets/img/print.svg" i18n-alt alt="Imprimir mapa"></div>
  <div  class="button" *ngIf="mostrarBotons" (click)="openShareDialog()"><img src="assets/img/share.svg" i18n-alt alt="Compartir"></div>
  <a  href="mailto:?subject=Feedback%20RACC%20Infotransit" class="button" *ngIf="mostrarBotons"><img src="assets/img/feedback.svg" i18n-alt style="top:40%;" alt="Dar feedback"></a>
  <div class="button"style="background: #969696 url(assets/img/language.svg) center center no-repeat;" *ngIf="mostrarBotons">
    <mat-form-field appearance="none">
      <mat-select [(value)]="selectedLanguage">
        <a href="/es">
          <mat-option [class.selected]="selectedLanguage === 'es'" value="es" >
            <img src="assets/img/espana.svg" alt=""> Español
         </mat-option>
        </a>
        
        <a href="/ca">
          <mat-option [class.selected]="selectedLanguage === 'ca'" value="ca">
            <img src="assets/img/catalonia.png" alt=""> Català
          </mat-option> 
        </a>
        
        
      </mat-select>
  </mat-form-field>
  </div>
  <div class="open-menu button"  [class.selected]="mostrarBotons" (click)="toggleButtons()" >
    <img  src="assets/img/burger.png" alt="Desplegar menú" height="24px">
    <!--<img *ngIf="mostrarBotons" src="assets/img/closeWhite.png" alt="Desplegar menú" height="24px">-->
  </div>
</div>
